import { ctaData } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20digital%20background%20with%20soft%20coral%20and%20amber%20tones%2C%20minimalist%20geometric%20flowing%20shapes%2C%20clean%20professional%20atmosphere%2C%20no%20text%2C%20smooth%20color%20transitions&width=1600&height=600&seq=cta-91-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/85 to-accent-700/75"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 font-heading">
          {ctaData.title}
        </h2>
        <p className="text-sm md:text-base text-white/75 mb-8 max-w-xl mx-auto">
          {ctaData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 bg-white text-primary-600 font-semibold rounded-lg hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm shadow-lg"
          >
            <i className="ri-shield-check-line mr-2"></i>
            {ctaData.buttonText}
          </a>
          <a
            href="#"
            className="px-8 py-3.5 border-2 border-white/40 text-white font-medium rounded-lg hover:bg-white/10 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            联系客服
          </a>
        </div>
      </div>
    </section>
  );
}